<template>
  <div class="table-wrapper">
    <TabulatorComponent v-model="analysisPapers" :options="options" id="ResultTable" />
  </div>
</template>

<script>
import { TabulatorComponent } from 'vue-tabulator';
import { getAnalysisPaperData } from '@/api/gradingPaper';

export default {
  name: 'ResultTable',
  components: {
    TabulatorComponent,
  },
  methods: {
    paperDataEditer(response) {
      const PapersLength = response.analysisResult.length;
      let papers = response.analysisResult;

      for (let paperNum = 0; paperNum < PapersLength; paperNum += 1) {
        let paper = papers[paperNum];
        paper.createdAt = this.convertToDate(paper.createdAt);
      }
      return papers;
    },
    convertToDate(milliseconds) {
      const createdDateObj = new Date(milliseconds);
      const createdDate = createdDateObj.toLocaleString().slice(0, -3);
      return createdDate;
    },
  },
  created() {
    getAnalysisPaperData().then((response) => {
      const editedPapers = this.paperDataEditer(response);
      this.analysisPapers = editedPapers;
    });
  },
  data() {
    return {
      analysisPapers: [],
      options: {
        height: '50vh',
        placeholder:
          this.$i18n.locale === 'eng' ? 'No gradebooks created...' : '생성된 채점지가 없습니다.',
        selectable: 1,
        columns: [
          {
            title: this.$i18n.locale === 'eng' ? 'created at' : '채점 날짜',
            field: 'createdAt',
            sorter: 'string',
            width: '50%',
          },
          {
            title: this.$i18n.locale === 'eng' ? 'grading sheet title' : '채점지 이름',
            field: 'title',
            sorter: 'string',
            width: '50%',
          },
        ],
        rowSelected: (row) => {
          this.$emit('updateSelectedResultId', row._row.data.examId);
          this.$emit('updateSelectedCreatedAt', row._row.data.createdAt);
        },
        rowDeselected: (row) => {
          this.$emit('updateSelectedResultId', 0);
        },
      },
    };
  },
  watch: {
    '$i18n.locale': function (newLocale, oldLocale) {
      this.options.columns[0].title = newLocale === 'eng' ? 'created at' : '채점 날짜';
      this.options.columns[1].title = newLocale === 'eng' ? 'grading sheet title' : '채점지 이름';
    },
  },
};
</script>

<style lang="scss">
.table-wrapper {
  margin: 20px 0;
}
.table-noresult {
  height: 200px;
  margin: 30px 0;
  border: 2px solid $MAIN-COLOR;
  border-radius: 10px;
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;

  p {
    line-height: 200px;
  }
}
#ResultTable {
  box-sizing: border-box;
  max-width: 1200px;
  margin: 30px auto 0px auto;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-collapse: collapse;
  table-layout: fixed;

  .tabulator-header {
    border-bottom: 2px solid $MAIN-COLOR;
    border-top: none;
  }

  .tabulator-col.tabulator-sortable {
    background-color: #f4f3ef;
  }

  .tabulator-row.tabulator-selected {
    background-color: $SUB-COLOR;
  }
}

@media (max-width: 992px) {
  #ResultTable {
    width: 100%;
  }
}
</style>
